import {
  EDITOR_CREATE_SESSION, EDITOR_SWITCH_BREAKPOINT, EDITOR_CREATE_WIDGET, EDITOR_DELETE_WIDGET,
  EDITOR_SELECT_WIDGET, EDITOR_SELECT_PAGE_WIDGET, EDITOR_UNSELECT_WIDGET, 
  EDITOR_SELECT_WIDGET_RANGE, EDITOR_APPLY_WIDGET_PROPERTY_CHANGES,
  EDITOR_UPDATE_PAGE_SETTINGS, EDITOR_UPDATE_WIDGET_CONTENT,
  EDITOR_UPDATE_WIDGET_NAME,

  ASSOCIATE_FONTS_WITH_WIDGET,
  EDITOR_ATTACH_TO_CONTAINER,
  EDITOR_UPDATE_GUIDELINES, EDITOR_APPLY_LAYOUT_CHANGES,
  EDITOR_TOGGLE_EDIT_MODE, EDITOR_TOGGLE_HOTSPOT_VIEW, TOGGLE_HOTSPOT_VIEW,

  EDITOR_INTERACTIVE_CONTENT_SWITCH_PAGE,
  EDITOR_UPDATE_TOOLS_SETTINGS,
  EDITOR_FORM_SWITCH_STEP, SUBMIT_CONTACT_FORM, SUBMIT_OTP_FORM, OTP_RESEND,
  EDITOR_UPDATE_WIDGET_EDITOR_STATE,
  EDITOR_BULK_UPDATE_WIDGET_EDITOR_STATE,
  UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST, UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED, UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED,
  LAYOUT_MANAGER_ARRANGE_CONTENT, UPDATE_DYNAMIC_LAYOUT_MANAGER, EDITOR_UPDATE_WIDGET_LAYOUT,

  UPDATE_LAYOUT_CONTENT, ADD_CONTENTS_TO_LAYOUT, RESET_LAYOUT_CONTENT, REMOVE_LAYOUT_CONTENTS,
  FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST, FETCHING_MAPPINGS_FOR_CONTENT_GRID_SUCCEEDED, FETCHING_MAPPINGS_FOR_CONTENT_GRID_FAILED,
  FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED, FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST, FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED, FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER, ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED, ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED,
  INVALIDATE_LAYOUT_MANAGER_MAPPINGS,

  CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST, CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED,

  EDITOR_REPLACE_WIDGETS,
  CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED,

  EDITOR_UPDATE_THEMES,
  EDITOR_UPDATE_BRAND_COLORS,
  EDITOR_BULK_UPDATE_WIDGET_LAYOUT, UPDATE_FILTERS_IN_CONTENT_GRID, RESET_FILTERS_IN_CONTENT_GRID, DELETING_ASSET_MAPPINGS_SUCCEEDED, RELOAD_LIVE_ELEMENT_ON_CHANGE, UPDATE_QUERY_IN_CONTENT_GRID,
  AUTO_SAVING_PAGE_SUCCEEDED,
  EDITOR_UPDATE_SPATIAL_SETTING_MODE,
  EDITOR_UPDATE_APPEARANCE,
  UPDATE_ALIAS_IN_LAYOUT_CONTENT, UPDATING_ALIASES_FOR_ASSET_SUCCEEDED,
  UPDATING_PAGE_SUCCEEDED,
  DELETE_VARIABLES_SUCCEEDED,
  UPDATE_VARIABLES_SUCCEEDED,
  EDITOR_SELECT_ACTIVE_SEGMENT,
  EDITOR_APPLY_BULK_WIDGET_PROPERTY_CHANGES,
  DESKTOP_TO_MOBILE_OPTIMIZE_REQUEST,
  DESKTOP_TO_MOBILE_OPTIMIZE_SUCCEEDED,
  DESKTOP_TO_MOBILE_OPTIMIZE_FAILED,
  MOBILE_LAYOUT_OPTIMIZE_REQUEST,
  MOBILE_LAYOUT_OPTIMIZE_SUCCEEDED,
  MOBILE_LAYOUT_OPTIMIZE_FAILED,
  DESKTOP_TO_MOBILE_OPTIMIZE,
  MOBILE_LAYOUT_OPTIMIZE
} from 'constants/actionTypes';

import { BUTTON, CAROUSEL_CARD, CONTENT, CONTENT_CARD, CONTENT_CARD_TEMPLATE, HOTSPOT, HTML, LIVE_ELEMENT, LIVE_ELEMENT_CONTAINER, MENU_CONTAINER, MENU_DRAGGABLE_CONTAINER, TEXT } from 'constants/widgetTypes';

import _ from 'lodash';
import undoable from 'redux-undo';
import { actionGroup } from 'actions/editor';
import { calculateOrderForWidgets, calculateOrderForWidget, getWidgetsWithAncestor, getAttachedWidgetLayout, findFontsFromHTML, getWidgetType, findPageWidgetForElement } from 'components/Editor/helper/widget';
import { themes as DEFAULT_THEMES } from 'constants/themes';
import { isWidgetLocked } from 'components/Editor/hooks/useEditorSession';
import { disableAutoGrowInWidgetTree, getDescendantIds } from 'components/Editor/components/autoGrow';

function createEditorSessionReducerFn(id) {
  const initialState = {
    id: id,
    breakpoint: 'desktop',
    mobileOptimization: {
      pageWidgets: {},
      desktopToMobileOptimized: false
    },
    desktop: {
      guides: {
        horizontal: [],
        vertical: []
      }
    },
    mobile: {
      guides: {
        horizontal: [],
        vertical: []
      }
    },
    widgets: [],
    selected: [],
    editMode: null,
    spatialSettingMode: null,
    layoutIndicator: false,
    interactive: {
      active: null
    },
    tools: {
      toolbar: true,
      layers: true,
      rulers: true,
      variables: false,
      gridlines: true
    },
    layoutManager: {
      id: null,
      items: [],
      filters: [],
      pagination: {
        current: -1,
        totalPages: 1
      }
    }
  }

  const initialMappingState = {
    pagination: {
      current: -1,
      totalPages: 1
    },
    loading: false,
    items: []
  }

  return (state = initialState, action) => {

    switch (action.type) {
      case EDITOR_CREATE_SESSION: {
        const { id, session } = action.payload;

        if (id !== state.id) {
          return state;
        }

        return {
          ...state,
          
          ...session
        }
      }

      case EDITOR_SWITCH_BREAKPOINT: {
        const { editorSession, breakpoint } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        let layoutIndicator = state.layoutIndicator;
        if (breakpoint == 'mobile') {
          layoutIndicator = false
        }

        return {
          ...state,
          breakpoint: breakpoint,
          layoutIndicator: layoutIndicator,
          selected: []
        }
      }

      case EDITOR_UPDATE_GUIDELINES: {
        const { editorSession, direction, breakpoint, guides } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          [breakpoint]: {
            guides: {
              ...state[breakpoint].guides,
              [direction]: guides
            }
          }
        }
      }

      case EDITOR_CREATE_WIDGET: {
        const { editorSession, widgets, selectOnCreation, parent } = action.payload;
        if (editorSession !== state.id) {
          return state;
        }

        const existingWidgets = [...state.widgets];
        const parents = [];

        const layoutIndicator = selectOnCreation && state.breakpoint === 'desktop';

        widgets.forEach(widget => {
          const order = calculateOrderForWidget(existingWidgets, widget.parent);

          existingWidgets.push({
            ...widget,
            order: order
          });

          parents.push(widget.uid);
        });

        var updatedState = {
          ...state,
          widgets: [...existingWidgets],
          layoutIndicator: layoutIndicator,
          mobileOptimization: {
            ...state.mobileOptimization,
            pageWidgets: {
              ...state.mobileOptimization.pageWidgets,
              [parent]: {
                ...state.mobileOptimization.pageWidgets[parent],
                desktopToMobileOptimized: false
              }
            },
            desktopToMobileOptimized: false
          }
        }

        if(updatedState.selectedPage !== parent && parent) {
          updatedState.selectedPage = parent;
        }

        if (selectOnCreation) {
          const selectedWidgets = widgets.filter(widget => {
            return !_.includes(parents, widget.parent);
          }).map(w => w.uid);

          updatedState.selected = selectedWidgets;
        }

        return updatedState;
      }

      case EDITOR_DELETE_WIDGET: {
        const { editorSession, widgets } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgetsToDelete = [...widgets];

        const pageId = findPageWidgetForElement(widgetsToDelete[0]);

        widgets.forEach(widget => {
          const additionalWidgets = getWidgetsWithAncestor(state.widgets, widget);
          widgetsToDelete = [...widgetsToDelete, ...additionalWidgets];
        });

        var updatedWidgets = [...state.widgets];

        // clear actions
        updatedWidgets = updatedWidgets.map((w) => {
          if(w.type === MENU_CONTAINER || w.type === MENU_DRAGGABLE_CONTAINER) {
            const content = (w.content || []).map((a) => {
              if(a?.action?.type === 'carousel' && widgetsToDelete.includes(a.action.value.slideUid || a.action.value.carouselUid)) {
                return { ...a, action: null };
              } else if(a.children) {
                const children = (a.children || []).map((a) => {
                  if(a?.action?.type === 'carousel' && widgetsToDelete.includes(a.action.value.slideUid || a.action.value.carouselUid)) {
                    return { ...a, action: null };
                  } else {
                    return a;
                  }
                });
                return { ...a, children };
              } else {
                return a;
              }
            });
            return { ...w, content };
          }

          let removedActions = [];
          removedActions = (w.actions || []).filter((a) => {
            const removed = (a.type === 'carousel' && widgetsToDelete.includes(a.value.slideUid || a.value.carouselUid));
            if(removed && w.type === TEXT) {
              w.content = w.content.replace(/<a[^>]*>(.*?)<\/a>/g, '$1');
            }
            return removed;
          });

          return { ...w, actions: removedActions.length === 0 ? w.actions : null };
        });

        updatedWidgets = updatedWidgets.filter(item => {
          return !widgetsToDelete.some(id => id === item.uid);
        });

        updatedWidgets = calculateOrderForWidgets(updatedWidgets, null);

        var selectedWidgets = [...state.selected];
        selectedWidgets = selectedWidgets.filter(item => {
          return !widgetsToDelete.some(id => id === item);
        });

        return {
          ...state,
          mobileOptimization: {
            ...state.mobileOptimization,
            desktopToMobileOptimized: false
          },
          selected: selectedWidgets,
          editMode: null,
          widgets: updatedWidgets,
          layoutIndicator: state.breakpoint === 'desktop',
          mobileOptimization: pageId ? {
            ...state.mobileOptimization,
            pageWidgets: {
              ...state.mobileOptimization.pageWidgets,
              [pageId]: {
                ...state.mobileOptimization.pageWidgets?.[pageId],
                desktopToMobileOptimized: false
              }
            },
            desktopToMobileOptimized: false
          } : state.mobileOptimization
        }
      }

      case EDITOR_SELECT_WIDGET: {
        const { editorSession, widgets } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var selected = widgets;
        selected = _.uniq(selected);
        const currentSelection = state.selected;
        if (_.isEqual(currentSelection, selected)) {
          return state;
        }

        return {
          ...state,
          selected: selected,
          editMode: null
        }
      }

      case EDITOR_SELECT_PAGE_WIDGET: {
        const { editorSession, widget } = action.payload;
        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          selectedPage: widget,
          activeSegment: widget,
          selected: [],
          editMode: null
        };
      }

      case EDITOR_SELECT_ACTIVE_SEGMENT: {
        const { editorSession, activeSegment } = action.payload;
        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          activeSegment: activeSegment,
        };
      }

      case EDITOR_UNSELECT_WIDGET: {
        const { editorSession, widgets } = action.payload
        if (editorSession !== state.id) {
          return state;
        }

        var unselectedWidget = state.selected.filter((data) => { return data !== widgets })
        return {
          ...state,
          selected: unselectedWidget,
        }
      }

      case EDITOR_SELECT_WIDGET_RANGE:
        const { editorSession, startIndex, endIndex, allWidgets } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }
        const rangeWidgets = [];
        const start = Math.min(startIndex, endIndex);
        const end = Math.max(startIndex, endIndex);

        for (let i = start; i <= end; i++) {
          if (allWidgets[i]) {
            rangeWidgets.push(allWidgets[i].uid);
          }
        }

        return {
          ...state,
          selected: rangeWidgets,
          editMode: null
        };

      case EDITOR_ATTACH_TO_CONTAINER: {
        const { editorSession, widget, container, layout } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        const pageId = findPageWidgetForElement(container);
        var widgets = state.widgets || [];
        const containerWidget = widgets.find(item => item.uid === container);
        const isCarouselCard = containerWidget?.type === CAROUSEL_CARD;
        const descendantIds = isCarouselCard ? getDescendantIds(widgets, widget) : new Set();
        widgets = widgets.map(item => {

          let widgetProperties = item.properties
          if (item.uid === widget) {
            const order = calculateOrderForWidget(widgets, container);
            let properties = getAttachedWidgetLayout(widgets, container, layout, widgetProperties, item.type);
            let updatedItem = {
              ...item,
              parent: container,
              order: order,
              properties: properties
            };
            if ([HTML, LIVE_ELEMENT].includes(item.type) && isCarouselCard) {
              updatedItem = disableAutoGrowInWidgetTree(updatedItem);
            }
            return updatedItem;
          }
          if (isCarouselCard && descendantIds.has(item.uid) && [HTML, LIVE_ELEMENT].includes(item.type)) {
            return disableAutoGrowInWidgetTree(item);
          }

          return item;
        });
        let hotspot = null;

        if (containerWidget) {
          if (containerWidget.type === HOTSPOT) {
            hotspot = state.hotspot;
          } 
          else if (containerWidget.type === CAROUSEL_CARD) {
            const carousel = widgets.find(w => w.uid === containerWidget.parent);
            if (carousel) {
              const carouselParentType = getWidgetType(editorSession, carousel.parent);
              hotspot = carouselParentType === HOTSPOT ? state.hotspot : null;
            }
          }
        }

        return {
          ...state,
          mobileOptimization: {
            ...state.mobileOptimization,
            desktopToMobileOptimized: false
          },
          selected: [],
          widgets: widgets,
          layoutIndicator: state.breakpoint === 'desktop',
          hotspot: hotspot,
          mobileOptimization: pageId ? {
            ...state.mobileOptimization,
            pageWidgets: {
              ...state.mobileOptimization.pageWidgets,
              [pageId]: {
                ...state.mobileOptimization.pageWidgets?.[pageId],
                desktopToMobileOptimized: false
              }
            },
            desktopToMobileOptimized: false
          } : state.mobileOptimization
        }

      }

      case EDITOR_APPLY_WIDGET_PROPERTY_CHANGES: {
        const { editorSession, changes, currentBreakpoint, availableFonts, bypassLock = false } = action.payload;
      
        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        widgets = widgets.map(item => {
          const change = changes[item.uid];
          if (!change) {
            return item;
          }
          const isLocked = isWidgetLocked(widgets, item, currentBreakpoint);
          const isLockToggle = typeof change.value === "object" && change.value.hasOwnProperty("locked");
          if (!bypassLock && isLocked && !isLockToggle) {
            return item;
          }      
      
          const widgetParent = widgets.find(widget => widget.uid === item.parent);
          var updatedItem = _.cloneDeep(item);

          // Handle TEXT inside CONTENT
          if (item.type === CONTENT) {
            for (const itemChange of Object.values(change.value || {})) {
              const overrides = itemChange?.overrides || {};
              for (const [widgetKey, widgetValue] of Object.entries(overrides)) {
                const widgetIndex = widgets.findIndex(w => w.uid === widgetKey);
                if (widgetIndex !== -1 && widgets[widgetIndex].type === TEXT) {
                  const widget = widgets[widgetIndex];
                  const fontFamilies = findFontsFromHTML(widgetValue.content);
    
                  const fonts = fontFamilies.map(name => {
                    const font = availableFonts.find(item => item.fontFamily === name);
                    return font;
                  }).filter(item => item != null)
                  .map(font => font.id);

                  if (!Array.isArray(widget.fonts)) {
                    widget.fonts = [];
                  }

                  //prevent duplicates
                  for (const font of fonts) {
                    if (!widget.fonts.includes(font)) {
                      widget.fonts.push(font);
                    }
                  }
                                    
                  widgets[widgetIndex] = widget;
                }
             }
            }
          }

          const assetCardWidgetTypes = [CONTENT, CONTENT_CARD, CONTENT_CARD_TEMPLATE];
          const isContentCardChild = assetCardWidgetTypes.includes(widgetParent?.type);
          
          const isVisibleChanges = change?.value?.visible != null;
          var updatedValue = _.get(item, change.path);

          if (Array.isArray(change.value)) {
            updatedValue = change.value;
          } else if (typeof change.value == 'object') {
            updatedValue = {
              ...updatedValue,
              ...change.value
            }
          } else {
            updatedValue = change.value;
          }


          updatedItem = _.set(updatedItem, change.path, updatedValue);
      
          if (isContentCardChild) {
            const isDesktopPath = change.path.startsWith('properties.desktop');
            const isMobilePath = change.path.startsWith('properties.mobile');
            
            if (isDesktopPath || isMobilePath) {
              const sourceBreakpoint = isDesktopPath ? 'desktop' : 'mobile';
              const targetBreakpoint = isDesktopPath ? 'mobile' : 'desktop';
              const targetPath = change.path.replace(`properties.${sourceBreakpoint}`, `properties.${targetBreakpoint}`);

              const prevLayout = _.get(item, `properties.${targetBreakpoint}.layout`);
              const prevAnimation = _.get(item, `properties.${targetBreakpoint}.animation`);
              const prevFont = _.get(item, `properties.${targetBreakpoint}.font`);

              let syncedValue = _.cloneDeep(updatedValue);

              if (typeof syncedValue === 'object' && syncedValue !== null) {
                const preservedLayout = {
                  transform: prevLayout?.transform,
                  width: prevLayout?.width,
                  height: prevLayout?.height
                };

                if (syncedValue.layout && typeof syncedValue.layout === 'object') {
                  syncedValue.layout = { ...syncedValue.layout, ...preservedLayout };
                } else {
                  syncedValue = { ...syncedValue, ...preservedLayout };
                }

                if (prevAnimation || prevAnimation == null) {
                  if (syncedValue.animation && typeof syncedValue.animation === 'object') {
                    syncedValue.animation = prevAnimation;
                  } else {
                    syncedValue = { ...syncedValue, animation: prevAnimation };
                  }
                }

                if (prevFont || prevFont == null) {
                  if (syncedValue.font && typeof syncedValue.font === 'object') {
                    syncedValue.font = prevFont;
                  } else {
                    syncedValue = { ...syncedValue, font: prevFont };
                  }
                }
              }
              
              updatedItem = _.set(updatedItem, targetPath, syncedValue);
            }
          }
      
          if (currentBreakpoint === "mobile" && !isVisibleChanges) {
            updatedItem = {
              ...updatedItem,
              properties: {
                ...updatedItem.properties,
                mobile: {
                  ...updatedItem.properties?.mobile,
                  disableOptimize: true
                }
              }
            };
          }

          return updatedItem;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case EDITOR_APPLY_BULK_WIDGET_PROPERTY_CHANGES: {
        const { editorSession, changes, currentBreakpoint } = action.payload;
      
        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        widgets = widgets.map(item => {
          const change = changes[item.uid];
          if (!change) {
            return item;
          }

          const isVisibleChanges = change?.value?.visible != null;
          const original = _.get(item, change.path);
          let result = null;

          if (Array.isArray(change.value)) {
            result = change.value;
          } else if (typeof change.value === 'object' && change.value !== null && !Array.isArray(change.value)) {
            result = {};
          
            const updated = _.cloneDeep(original);

            // Merge the change into the clone
            result = _.merge(updated, change.value);
            
            if (Object.keys(result).length === 0) {
              result = null;
            }
          } else {
            result = change.value;
          }

          var updatedItem = _.cloneDeep(item);
          updatedItem = _.set(updatedItem, change.path, result);
      
          if (currentBreakpoint === "mobile" && !isVisibleChanges) {
            updatedItem = {
              ...updatedItem,
              properties: {
                ...updatedItem.properties,
                mobile: {
                  ...updatedItem.properties?.mobile,
                  disableOptimize: true
                }
              }
            };
          }

          return updatedItem;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case EDITOR_UPDATE_PAGE_SETTINGS: {
        const { editorSession, widget, uid, breakpoint, property } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];

        widgets = widgets.map(item => {
          var clonedItem = widget != null ? widget : item;
          if (item.uid === (widget != null ? widget.uid : uid)) {
            return {
              ...clonedItem,
              properties: {
                ...item.properties,
                [breakpoint]: {
                  ...item.properties[breakpoint],
                  ...property
                }
              }
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case EDITOR_UPDATE_WIDGET_CONTENT: {
        const { editorSession, widget, content } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        widgets = widgets.map(item => {
          if (item.uid === widget) {
            return {
              ...item,
              content: content
            }
          }
          return item;
        });

        return {
          ...state,
          layoutIndicator: state.breakpoint === 'desktop',
          widgets: widgets
        }
      }

      case EDITOR_UPDATE_THEMES: {
        const { editorSession, format, theme } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var themes = state.themes || DEFAULT_THEMES;
        themes = themes.map(item => {
          if (item.type === format) {
            return {
              ...item,
              font: theme
            }
          }

          return item;
        });

        return {
          ...state,
          themes: themes
        }
      }

      case EDITOR_UPDATE_APPEARANCE: {
        const { editorSession, appearance } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          appearance: {
            ...state.appearance,
            ...appearance
          }
        }
      }

      case EDITOR_UPDATE_BRAND_COLORS: {
        const { editorSession, colors } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          brandTheme: {
            colors: colors
          }
        }
      }

      case EDITOR_UPDATE_TOOLS_SETTINGS: {
        const { editorSession, settings } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          tools: {
            ...state.tools,
            ...settings
          }
        }

      }

      case EDITOR_APPLY_LAYOUT_CHANGES: {
        const { editorSession, breakpoint, changes } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        widgets = widgets.map(item => {
          const change = changes[item.uid];
          if (!change) {
            return item;
          }

          return {
            ...item,
            properties: {
              ...item.properties,
              [breakpoint]: {
                ...item.properties[breakpoint],
                layout: {
                  ...item.properties[breakpoint].layout,
                  ...change
                }
              }
            }
          }
        });

        return {
          ...state,
          widgets: widgets,
          layoutIndicator: breakpoint === 'desktop'
        }
      }

      case EDITOR_TOGGLE_EDIT_MODE: {
        const { editorSession, widget, edit, view, batchEdit } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var value = null;
        if (edit) {
          value = widget;
        }

        return {
          ...state,
          editMode: value,
          editView: view,
          batchEdit: batchEdit
        }

      }

      case EDITOR_UPDATE_SPATIAL_SETTING_MODE: {
        const { editorSession, view } = action.payload;

        if (editorSession !== state.id && !view) {
          return state;
        }

        return {
          ...state,
          spatialSettingMode: view
        }
      }

      case EDITOR_TOGGLE_HOTSPOT_VIEW:
      case TOGGLE_HOTSPOT_VIEW: {
        const { editorSession, id } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          hotspot: id
        }
      }

      case EDITOR_UPDATE_WIDGET_EDITOR_STATE: {
        const { editorSession, widget, editorState } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        widgets = widgets.map(item => {
          if (item.uid === widget) {

            const currentState = item.editorState || {};
            var nextState = null;
            if (editorState) {
              nextState = {
                ...currentState,
                ...editorState
              }
            }

            return {
              ...item,
              editorState: nextState
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case EDITOR_BULK_UPDATE_WIDGET_EDITOR_STATE: {
        const { editorSession, widgetIds, editorState } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }
      
        const widgets = (state.widgets || []).map((item) => {
          if (widgetIds.includes(item.uid)) {
            const currentState = item.editorState || {};
            const nextState = editorState
              ? { ...currentState, ...editorState }
              : currentState;
      
            return {
              ...item,
              editorState: nextState,
            };
          }
          return item;
        });
      
        return {
          ...state,
          widgets,
        };
      }


      case DELETE_VARIABLES_SUCCEEDED: {
        const { response, editorSession } = action.payload;
        const deletedVariableId = response.id;
      
        if (editorSession !== state.id) {
          return state;
        }
      
        const widgets = (state.widgets || []).map(widget => {
          if (widget.type !== TEXT || !widget.content) {
            return widget;
          }
      
          // Create a dummy container to parse HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(widget.content, 'text/html');
      
          // Find spans with matching data-variable-id
          const spans = doc.querySelectorAll(`[data-variable-id="${deletedVariableId}"]`);
          spans.forEach(span => {
            const textNode = document.createTextNode(span.textContent);
            span.replaceWith(textNode);
          });
      
          return {
            ...widget,
            content: doc.body.innerHTML
          };
        });
      
        return {
          ...state,
          widgets
        };
      }


      case UPDATE_VARIABLES_SUCCEEDED: {
        const { response, editorSession } = action.payload;
        const updatedVariableId = response.id;
        if (editorSession !== state.id) {
          return state;
        }
      
        const widgets = (state.widgets || []).map(widget => {
          if (widget.type !== TEXT || !widget.content) {
            return widget;
          }
      
          // Create a dummy container to parse HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(widget.content, 'text/html');
      
          // Find spans with matching data-variable-id
          const spans = doc.querySelectorAll(`[data-variable-id="${updatedVariableId}"]`);
          spans.forEach(span => {
            span.textContent = response.name;
            span.setAttribute('data-original-variable', response.name); 
          });
      
          return {
            ...widget,
            content: doc.body.innerHTML
          };
        });
      
        return {
          ...state,
          widgets
        };
      }
      

      case ASSOCIATE_FONTS_WITH_WIDGET: {
        const { editorSession, widget, fonts } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        widgets = widgets.map(item => {
          if (item.uid === widget) {
            return {
              ...item,
              fonts: fonts
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case EDITOR_INTERACTIVE_CONTENT_SWITCH_PAGE: {
        const { editorSession, section } = action.payload;

        if (editorSession != state.id) {
          return state;
        }

        return {
          ...state,
          selected: [],
          editMode: null,
          hotspot: null,
          interactive: {
            ...state.interactive,
            active: section
          }
        }
      }

      case EDITOR_FORM_SWITCH_STEP: {
        const { editorSession, form, step } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        const formWidet = widgets.find(widget => widget.uid === form);
        if (!formWidet) {
          return state
        }

        widgets = widgets.map(widget => {
          if (widget.uid === form) {
            return {
              ...widget,
              step: step
            }
          }

          return widget;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case SUBMIT_CONTACT_FORM: {
        const { editorSession, form } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        const formWidet = widgets.find(widget => widget.uid === form);
        if (!formWidet) {
          return state
        }

        widgets = widgets.map(widget => {
          if (widget.uid === form) {
            return {
              ...widget,
              success: true
            }
          }

          return widget;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case SUBMIT_OTP_FORM: {
        const { editorSession, form } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        const formWidet = widgets.find(widget => widget.uid === form);
        if (!formWidet) {
          return state
        }

        widgets = widgets.map(widget => {
          if (widget.uid === form) {
            return {
              ...widget,
              success: true,
              otpSuccess: true
            }
          }

          return widget;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case OTP_RESEND: {
        const { editorSession, form } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var widgets = state.widgets || [];
        const formWidet = widgets.find(widget => widget.uid === form);
        if (!formWidet) {
          return state
        }

        widgets = widgets.map(widget => {
          if (widget.uid === form) {
            return {
              ...widget,
              success: true,
              otpSuccess: false
            }
          }

          return widget;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case CREATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST: {
        const { editorSession, widget, request } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || []

        widgets = widgets.map(item => {
          if (item.uid === widget) {

            const currentState = item.editorState || {};
            var nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                creating: true,
                created: false,
                request: request
              }
            };

            return {
              ...item,
              editorState: nextState
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED: {
        const { editorSession, widget, response } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || []
        widgets = widgets.map(item => {
          if (item.uid === widget) {

            const currentState = item.editorState || {};
            var nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                creating: false,
                created: true,
                request: null
              },
            };

            return {
              ...item,
              content: response,
              editorState: nextState
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case CREATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED: {
        const { editorSession, widget, error } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || []

        widgets = widgets.map(item => {
          if (item.uid === widget) {

            const currentState = item.editorState || {};
            var nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                creating: false,
                created: false,
                error: error
              }
            };

            return {
              ...item,
              editorState: nextState
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case UPDATE_LAYOUT_MANAGER_FOR_CONTENT_GRID_REQUEST: {
        const { editorSession, widget, request } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || []

        widgets = widgets.map(item => {
          if (item.uid === widget) {

            const currentState = item.editorState || {};
            var nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                updating: true,
                updated: false,
                request: request
              }            
            };

            return {
              ...item,
              editorState: nextState
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_SUCCEEDED: {
        const { editorSession, widget, request, response } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];

        widgets = widgets.map(item => {
          if (item.uid === widget) {

            let mappingRequest = request.mappings || [];
            let changes = _.get(item, 'content.changes', {});

            mappingRequest.forEach(item => {
              if (_.has(changes, item.id)) {
                changes = _.omit(changes, [item.id]);
              }
            })

            const currentState = item.editorState || {};
            let nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                updating: false,
                updated: true,
                request: null,
                deletedMappings: []
              },
            };

            return {
              ...item,
              editorState: nextState,
              content: {
                ...response,
                changes: changes
              }
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case UPDATING_LAYOUT_MANAGER_FOR_CONTENT_GRID_FAILED: {
        const { editorSession, widget, error } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || []

        widgets = widgets.map(item => {
          if (item.uid === widget) {

            const currentState = item.editorState || {};
            var nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                updating: false,
                updated: false,
                error: error
              }
            };

            return {
              ...item,
              editorState: nextState,
            }
          }

          return item;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case LAYOUT_MANAGER_ARRANGE_CONTENT: {
        const { editorSession, widget, content, index } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let mappings = _.get(state, 'layoutManager.items', []);

        if (_.size(mappings) === 0) {
          return state;
        }

        let mapping = mappings.find(item => {
          return item.content.id === content;
        });

        const oldIndex = mappings.findIndex(item => item.content.id === content);
        mappings.splice(oldIndex, 1);
        mappings.splice(index, 0, mapping);

        var order = 0;
        mappings = mappings.map((item) => {
          order = order + 1;
          return {
            ...item,
            order: order
          }
        });

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: mappings
          }
        }
      }

      case UPDATE_DYNAMIC_LAYOUT_MANAGER: {
        const { editorSession, request } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            ...request
          }
        }
      }

      case UPDATE_FILTERS_IN_CONTENT_GRID: {
        const { editorSession, widget, filter } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];
        widgets = widgets.map(widgetItem => {
          if (widgetItem.uid === widget) {
            let mappings = _.get(widgetItem, 'content.mappings') || initialMappingState;
            var updatedFilters = _.get(widgetItem, 'filters') || [];
            updatedFilters = updatedFilters.filter(item => {
              return item.property.fieldId != filter.property.fieldId
            });

            if (filter.value) {
              updatedFilters = [...updatedFilters, filter]
            }

            return {
              ...widgetItem,
              filters: updatedFilters,
              content: {
                ...widgetItem.content,
                mappings: {
                  ...mappings,
                  fetch: true
                }
              }
            }
          }

          return widgetItem;
        })

        return {
          ...state,
          widgets: widgets
        }
      }

      case UPDATE_QUERY_IN_CONTENT_GRID: {
        const { editorSession, widget, query } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];
        widgets = widgets.map(widgetItem => {
          if (widgetItem.uid === widget) {

            return {
              ...widgetItem,
              query: query
            }
          }

          return widgetItem;
        })

        return {
          ...state,
          widgets: widgets
        }
      }

      case RESET_FILTERS_IN_CONTENT_GRID: {
        const { editorSession, widget } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];
        widgets = widgets.map(widgetItem => {
          if (widgetItem.uid === widget) {
            let mappings = _.get(widgetItem, 'content.mappings') || initialMappingState;

            return {
              ...widgetItem,
              filters: [],
              content: {
                ...widgetItem.content,
                mappings: {
                  ...mappings,
                  fetch: true
                }
              }
            }
          }

          return widgetItem;
        })

        return {
          ...state,
          widgets: widgets
        }
      }

      case FETCH_MAPPINGS_FOR_CONTENT_GRID_REQUEST: {
        const { editorSession, widget, layout, page, limit, preview } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];
        widgets = widgets.map((widgetItem) => {
          let mappings = _.get(widgetItem, 'content.mappings') || initialMappingState;

          let items = []

          if(preview){
            items = page === 0 ? [] : _.get(mappings, 'items')
          }
          
          if (widgetItem.uid === widget) {
            return {
              ...widgetItem,
              content: {
                ...widgetItem.content,
                mappings: {
                  ...mappings,
                  loading: true,
                  fetch: false,
                  items: items,
                  fetched: false
                }
              }
            }
          }

          return widgetItem;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case FETCHING_MAPPINGS_FOR_CONTENT_GRID_SUCCEEDED: {
        const { editorSession, widget, layout, response, preview } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];
        widgets = widgets.map((widgetItem) => {
          if (widgetItem.uid === widget) {
            let mappings = _.get(widgetItem, 'content.mappings.items', []);

            let items = [];

            const currentState = widgetItem.editorState || {};
            var nextState = {
              ...currentState,
              layout: {
                ...currentState.layout,
                updated: false,
              }
            };

            if (preview && response.currentPage !== 0) {
              items = [...mappings, ...response.records];
            } else {
              items = response.records
            }

            items = _.uniqBy(items, 'uid');

            return {
              ...widgetItem,
              content: {
                ...widgetItem.content,
                mappings: {
                  ...initialMappingState,
                  fetched: true,
                  loading: false,
                  items: items,
                  pagination: {
                    ...initialMappingState.pagination,
                    current: response.currentPage,
                    totalPages: response.totalPages,
                    totalRecordsCount: response.totalRecordsCount
                  }
                }
              },
              editorState: nextState,
            }
          }

          return widgetItem;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case FETCHING_MAPPINGS_FOR_CONTENT_GRID_FAILED: {
        const { editorSession, widget, layout, error } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];
        widgets = widgets.map((widgetItem) => {
          if (widgetItem.uid === widget) {
            return {
              ...widgetItem,
              content: {
                ...widgetItem.content,
                mappings: {
                  ...initialMappingState,
                  loading: false,
                  error: error
                }
              }
            }
          }

          return widgetItem;
        });

        return {
          ...state,
          widgets: widgets
        }
      }

      case FETCH_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST: {
        const { editorSession, widget, layout, page, limit } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let items = _.get(state, 'layoutManager.items') || [];
        if (page === 0) {
          items = [];
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            id: layout,
            loading: true,
            items: items
          }
        }
      }

      case FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED: {
        const { editorSession, widget, layout, response } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];

        const selectedWidget = widgets.find(item => {
          return item.uid === widget;
        })

        const gridContent = _.get(selectedWidget, 'content');
        var changes = _.get(gridContent, 'changes') || {};

        let items = _.get(state, 'layoutManager.items') || [];

        if (response.currentPage !== 0) {
          items = [...items, ...response.records];
        } else {
          items = [...response.records]
        }

        items = _.uniqBy(items, 'id');

        items = items.filter(item => item.content != null).map(item => {
          let change = changes[item.id];

          if (_.has(change, 'overrides.name.key')) {
            item = {
              ...item,
              name: _.get(change, 'overrides.name.content'),
              override: true
            }
          }

          if (_.has(change, 'overrides.icon.key')) {
            item = {
              ...item,
              icon: _.get(change, 'overrides.icon.content'),
              override: true
            }
          }

          if (_.has(change, 'overrides.description.key')) {
            item = {
              ...item,
              icon: _.get(change, 'overrides.description.content'),
              override: true
            }
          }

          return item;
        });

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            id: layout,
            loading: false,
            items: items,
            pagination: {
              ...initialMappingState.pagination,
              current: response.currentPage,
              totalPages: response.totalPages,
              totalRecordsCount: response.totalRecordsCount
            }
          }
        }
      }

      case FETCHING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED: {
        const { editorSession, widget, layout, error } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            id: layout,
            loading: false,
            error: error
          }
        }
      }

      case FETRCH_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_REQUEST: {
        const { editorSession, widget, layout, request, page, limit } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let items = _.get(state, 'layoutManager.items') || [];
        if (page === 0) {
          items = [];
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            loading: true,
            items: items
          }
        }
      }

      case FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED: {
        const { editorSession, widget, layout, response } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        let widgets = state.widgets || [];

        const selectedWidget = widgets.find(item => {
          return item.uid === widget;
        })

        const gridContent = _.get(selectedWidget, 'content');
        var changes = _.get(gridContent, 'changes') || {};

        let items = _.get(state, 'layoutManager.items') || [];

        if (response.currentPage !== 0) {
          items = [...items, ...response.records];
        } else {
          items = [...response.records]
        }

        items = _.uniqBy(items, 'id');

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            loading: false,
            items: items,
            pagination: {
              ...initialMappingState.pagination,
              current: response.currentPage,
              totalPages: response.totalPages,
              totalRecordsCount: response.totalRecordsCount
            }
          }
        }
      }

      case FETCHING_FILTER_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED: {
        const { editorSession, widget, layout, error } = action.payload;

        if (editorSession !== state.id && !widget) {
          return state;
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            loading: false,
            error: error
          }
        }
      }

      case INVALIDATE_LAYOUT_MANAGER_MAPPINGS: {
        return {
          ...state,
          layoutManager: _.cloneDeep(initialState.layoutManager)
        }
      }

      case UPDATE_LAYOUT_CONTENT: {
        const { editorSession, contentGrid, content, request } = action.payload;

        if (editorSession !== state.id && !contentGrid && !content) {
          return state;
        }

        let mappings = _.get(state, 'layoutManager.items', []);
        mappings = mappings.map(item => {
          if (_.get(item, 'content.id') === content) {
            const fields = (item.fields || []).map(field => {
              if (field.name === request.name) {
                return request;
              }

              return field
            });

            return {
              ...item,
              changes: true,
              fields: fields
            }
          }

          return item;
        })

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: mappings
          }
        }
      }

      case UPDATE_ALIAS_IN_LAYOUT_CONTENT: {
        const { editorSession, content, alias } = action.payload;

        if (editorSession !== state.id && !content) {
          return state;
        }

        let mappings = _.get(state, 'layoutManager.items', []);
        mappings = mappings.map(item => {
          if (_.get(item, 'content.id') === content) {
            return {
              ...item,
              url: alias,
              aliasChanged: true
            }
          }

          return item;
        })

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: mappings
          }
        }
      }

      case UPDATING_ALIASES_FOR_ASSET_SUCCEEDED: {
        const { id, response, prevAlias } = action.payload;

        let mappings = _.get(state, 'layoutManager.items', []);
        mappings = mappings.map(item => {
          if (prevAlias === item.url) {
            return {
              ...item,
              url: response.url
            }
          }

          return item;
        })

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: mappings
          }
        }
      }

      case ADD_CONTENTS_TO_LAYOUT: {
        const { editorSession, widgetId, mappings } = action.payload;

        if (editorSession !== state.id && !widgetId) {
          return state;
        }

        let items = _.get(state, 'layoutManager.items', []);

        const newMappings = mappings.filter(mapping => {
          var content = _.get(mapping, 'content.id');
          const contentType = _.get(mapping, 'type');

          const existing = items.find(item => {
            const existingContent = _.get(item, 'content.id');
            const existingContentType = _.get(item, 'type');
            return contentType === existingContentType && content === existingContent;
          })

          if (!existing) {
            return true;
          }

          return false;
        });

        items = [...items, ...newMappings];

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: items
          }
        }
      }

      case RESET_LAYOUT_CONTENT: {
        const { editorSession, widgetId, contentId } = action.payload;

        if (editorSession !== state.id && !widgetId) {
          return state;
        }

        let items = _.get(state, 'layoutManager.items', []);
        items = items.map(item => {
          if (item.content.id === contentId) {
            return {
              ...item,
              name: _.get(item, 'content.name', ''),
              summary: _.get(item, 'content.summary', ''),
              icon: _.get(item, 'content.icon', null),
              override: false
            }
          }

          return item;
        })


        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: items
          }
        }
      }

      case ARRANGE_MAPPINGS_FOR_LAYOUT_MANAGER: {
        const { editorSession, layout } = action.payload;

        if (editorSession !== state.id && layout !== state.layoutManager.id) {
          return state;
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            arranging: true
          }
        }
      }

      case ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_SUCCEEDED: {
        const { editorSession, layout, response } = action.payload;

        if (editorSession !== state.id && layout !== state.layoutManager.id) {
          return state;
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            arranging: false
          }
        }
      }

      case ARRANGING_MAPPINGS_FOR_LAYOUT_MANAGER_FAILED: {
        const { editorSession, layout, error } = action.payload;

        if (editorSession !== state.id && layout !== state.layoutManager.id) {
          return state;
        }

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            arranging: false,
            error: error
          }
        }
      }

      case REMOVE_LAYOUT_CONTENTS: {
        const { editorSession, widgetId, contents } = action.payload;

        if (editorSession !== state.id && !widgetId) {
          return state;
        }

        let widgets = state.widgets || [];

        let selectedWidget = widgets.find(item => {
          return item.uid === widgetId;
        })

        if (!selectedWidget) {
          return state;
        }

        var mappings = _.get(state, 'layoutManager.items', []);
        var deletedMappings = _.get(state, 'layoutManager.deletedMappings', []);

        let mapping = null;
        var mappingsToBeDeleted = contents.map(id => {
          mapping = mappings.find(item => item.content.asset.id === id);
          return mapping && mapping.id ? mapping.id : null
        }).filter(item => item != null);

        deletedMappings = [...deletedMappings, ...mappingsToBeDeleted];
        deletedMappings = _.uniq(deletedMappings);

        mappings = mappings.filter(item => !contents.includes(item.content.asset.id));

        let widgetMappings = _.get(selectedWidget, 'content.mappings.items', []);
        widgetMappings = widgetMappings.filter(item => !contents.includes(_.get(item, 'content.asset.id', null)));

        widgets = widgets.map(item => {
          if(item.uid === widgetId) {
            return {
              ...item,
              content: {
                ...item.content,
                mappings: {
                  ...item.content.mappings,
                  items: widgetMappings
                }
              }
            }
          }

          return item;
        })

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: mappings,
            deletedMappings: deletedMappings
          },
          widgets: widgets
        }
      }

      case DELETING_ASSET_MAPPINGS_SUCCEEDED: {
        const { request } = action.payload;

        const layoutManger = _.get(state, 'layoutManager', {});
        let contentMappings = _.get(layoutManger, 'items', []);
        contentMappings = contentMappings.filter(item => !(request.mappings).includes(item.content.id));

        return {
          ...state,
          layoutManager: {
            ...state.layoutManager,
            items: contentMappings,
          }
        }
      }

      case EDITOR_REPLACE_WIDGETS: {
        const { editorSession, widgets } = action.payload;

        if (editorSession !== state.id) {
          return state;
        }

        var existingWidgets = state.widgets || [];

        existingWidgets = existingWidgets.filter(item => {
          var index = widgets.findIndex(widget => {
            return widget.uid === item.uid;
          })

          return index === -1;
        });

        existingWidgets = [
          ...existingWidgets,
          ...widgets
        ]

        return {
          ...state,
          widgets: existingWidgets
        }
      }

      case RELOAD_LIVE_ELEMENT_ON_CHANGE: {
        const { element } = action.payload;
        
        const liveElementWidget = state.widgets.find(item => {
          return item.type === LIVE_ELEMENT && item.content === element.id;
        });

        const newContainer = element.content.widgets.find(item => {
          return item.type === LIVE_ELEMENT_CONTAINER;
        });

        const liveElementContainer = state.widgets.find(item => {
          return item.type === LIVE_ELEMENT_CONTAINER && item.uid === newContainer.uid;
        });

        console.log(liveElementWidget, liveElementContainer);
        if(!liveElementWidget && !liveElementContainer){
          return state;
        }

        let existingWidgets = [...state.widgets];

        if(liveElementWidget){
          existingWidgets = existingWidgets.map(widget => {
            if(widget.type === LIVE_ELEMENT && widget.content === element.id){
              widget = {
                ...widget,
                children: element.content.widgets,
              }

              const desktopWidth = _.get(newContainer, 'properties.desktop.layout.width');
              const desktopHeight = _.get(newContainer, 'properties.desktop.layout.height');
              const mobileWidth = _.get(newContainer, 'properties.mobile.layout.width');
              const mobileHeight = _.get(newContainer, 'properties.mobile.layout.height');

              _.set(widget, 'properties.desktop.layout.width', desktopWidth);
              _.set(widget, 'properties.desktop.layout.height', desktopHeight);
              _.set(widget, 'properties.mobile.layout.width', mobileWidth);
              _.set(widget, 'properties.mobile.layout.height', mobileHeight);
            }
  
            return widget;
          });

        } else if(liveElementContainer){
          existingWidgets = [...element.content.widgets];
        }
        
        return {
          ...state,
          widgets: existingWidgets
        }
      }

      case AUTO_SAVING_PAGE_SUCCEEDED: {
        const { editorSession, response } = action.payload;

        if(state.id != editorSession){
          return state;
        }

        const widgets = _.get(response, 'draft.widgets') || [];
        var existingWidgets = [...state.widgets];
        existingWidgets = existingWidgets.map(widget => {
          const widgetResponse = widgets.find(item => item.uid === widget.uid);
          if(widgetResponse){
            return {
              ...widgetResponse,
              ...widget,
              id: widgetResponse.id
            }
          }

          return widget;
        });

        return {
          ...state,
          widgets: existingWidgets
        }
      }

      case UPDATING_PAGE_SUCCEEDED: {
        const { editorSession, response } = action.payload;

        if(state.id !== editorSession){
          return state;
        }

        const widgets = _.get(response, 'draft.widgets') || [];
        var existingWidgets = [...state.widgets];
        existingWidgets = existingWidgets.map(widget => {
          const widgetResponse = widgets.find(item => item.uid === widget.uid);
          const contentWidget = widget.type === CONTENT;
          if(widgetResponse){
            return {
              ...widget,
              ...widgetResponse,
              id: widgetResponse.id,
              content: contentWidget ? _.get(widget, 'content') : _.get(widgetResponse, 'content'),
              properties: widgetResponse.properties
            }
          }

          return widget;
        });

        return {
          ...state,
          widgets: existingWidgets
        }
      }

      case DESKTOP_TO_MOBILE_OPTIMIZE:
      case MOBILE_LAYOUT_OPTIMIZE: {
        const { editorSession, breakpoint, pageId, pageWidget, storyboardId } = action.payload;
        const pageWidgetId = pageWidget.uid;
        if(state.id !== editorSession){
          return state;
        }

        return {
          ...state,
          mobileOptimization: {
            ...state.mobileOptimization,
            pageWidgets: {
              ...state.mobileOptimization.pageWidgets,
              [pageWidgetId]: {
                optimizing: true,
                view: breakpoint ? "desktop" : "mobile",
                optimized: false,
                desktopToMobileOptimized: true
              }
            },
            desktopToMobileOptimized: true
          }
        }
      }

      // case DESKTOP_TO_MOBILE_OPTIMIZE_REQUEST:
      // case MOBILE_LAYOUT_OPTIMIZE_REQUEST:
      // {
      //   const { editorSession, request, rawRequest } = action.payload;
      //   const pageWidgetId = rawRequest.pageWidgetId;
      //   if(state.id !== editorSession){
      //     return state;
      //   }
      //   const view = rawRequest.view;

      //   return {
      //     ...state,
      //     mobileOptimization: {
      //       ...state.mobileOptimization,
      //       pageWidgets: {
      //         ...state.mobileOptimization.pageWidgets,
      //         [pageWidgetId]: {
      //           optimizing: true,
      //           view: view,
      //           optimized: false 
      //         }
      //       },
      //       desktopToMobileOptimized: true
      //     }
      //   }

      // }

      case DESKTOP_TO_MOBILE_OPTIMIZE_SUCCEEDED:
      case MOBILE_LAYOUT_OPTIMIZE_SUCCEEDED:
      {
        const { editorSession, response, rawRequest } = action.payload;
        const pageWidgetId = rawRequest.pageWidgetId;
        if(state.id !== editorSession){
          return state;
        }
        const view = rawRequest.view;

        return {
          ...state,
          mobileOptimization: {
            ...state.mobileOptimization,
            pageWidgets: {
              ...state.mobileOptimization.pageWidgets,
              [pageWidgetId]: {
                optimizing: false,
                view: view,
                optimized: true,
                desktopToMobileOptimized: true
              }
            }
          }
        }
      }

      case DESKTOP_TO_MOBILE_OPTIMIZE_FAILED:
      case MOBILE_LAYOUT_OPTIMIZE_FAILED:
      {
        const { editorSession, error, rawRequest } = action.payload;
        const pageWidgetId = rawRequest.pageWidgetId;
        if(state.id !== editorSession){
          return state;
        }
        const view = rawRequest.view;
        
        return {
          ...state,
          mobileOptimization: {
            ...state.mobileOptimization,
            pageWidgets: {
              ...state.mobileOptimization.pageWidgets,
              [pageWidgetId]: {
                optimizing: false,
                view: view,
                error: error,
                desktopToMobileOptimized: false
              }
            },
            desktopToMobileOptimized: false
          }
        }
      }

      default:
        return state
    }
  }
}

const createEditorSessionReducer = (id) => {
  const undoableReducer = undoable(createEditorSessionReducerFn(id), {
    limit: 50,
    undoType: `UNDO_${id}`,
    redoType: `REDO_${id}`,
    debug: true,
    syncFilter: true,
    filter: function excludeNonEditorActions(action) {
      if (!action.type.startsWith("EDITOR_")) return false;

      const excludedTypes = [
        EDITOR_CREATE_SESSION, EDITOR_SELECT_WIDGET, EDITOR_UPDATE_APPEARANCE, EDITOR_SELECT_PAGE_WIDGET,
        EDITOR_SWITCH_BREAKPOINT, ASSOCIATE_FONTS_WITH_WIDGET, EDITOR_UPDATE_THEMES,
        EDITOR_UPDATE_WIDGET_NAME, EDITOR_UPDATE_PAGE_SETTINGS, EDITOR_UPDATE_WIDGET_LAYOUT,
        EDITOR_BULK_UPDATE_WIDGET_LAYOUT, EDITOR_UPDATE_TOOLS_SETTINGS
      ];
      return !excludedTypes.includes(action.type);
    },
    groupBy: actionGroup.init([])
  });

  return function skipLoadingOnUndoRedo(state, action) {
    let newState = undoableReducer(state, action);

    if (action.type === `UNDO_${id}` || action.type === `REDO_${id}`) {
      while (newState.present?.widgets?.some(w => w.uid?.includes("widget_loading"))) {
        const nextAction = {
          type: action.type,
        };
        newState = undoableReducer(newState, nextAction);
        if (
          (action.type === `UNDO_${id}` && newState.past.length === 0) ||
          (action.type === `REDO_${id}` && newState.future.length === 0)
        ) {
          break;
        }
      }
    }

    return newState;
  };
};

export { createEditorSessionReducer };